import { render, staticRenderFns } from "./LoaderSpin.vue?vue&type=template&id=2327c236"
import script from "./LoaderSpin.vue?vue&type=script&lang=js"
export * from "./LoaderSpin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports